export default {
  getAddMonthOracle(todayObject, addMonth){
    let today = todayObject
    let dayOfToday = today.getDate()
    let lastDayOfThisMonth = new Date(todayObject.getFullYear(), todayObject.getMonth() + 1, 0).getDate()

    let addedMonth = new Date(today.getFullYear(), today.getMonth() + addMonth, 1)
    let lastDayOfAddMonth = new Date(addedMonth.getFullYear(), addedMonth.getMonth() + 1, 0).getDate()

    let addMonthOracle
    if (dayOfToday >= lastDayOfAddMonth || lastDayOfThisMonth === dayOfToday) {
      addMonthOracle = new Date(addedMonth.getFullYear(), addedMonth.getMonth() + 1, 0)
    } else {
      addMonthOracle = new Date(addedMonth.getFullYear(), addedMonth.getMonth(), dayOfToday)
    }

    return addMonthOracle
  }
}